export interface Credentials {
  id?: string;
  clientKey: string;
  type: string;
  data?: any;
  name: string;
  description?: string;
  created?: number;
}
export interface BasicCredentials {
  username: string;
  password: string;
}
export interface TokenCredentials {
  token: string;
}

export interface Oauth2Credentials {
  config: {
    client: {
      id: string;
      secret: string;
    };
    url: {
      authorizeUrl: string;
      accessTokenUrl: string;
    };
    grantType: string;
    scope: string;
    code: string;
    headerPrefix?: string;
  };

  response: {
    accessToken: any;
  };
}

export interface JwtCredentials {
  claims: string;
  secret: {
    value: string;
    isBase64: boolean;
  };
  headerPrefix: string;
  algorithm: string;
  useAsVariable: boolean;
}

export interface CustomHeaders {
  headers: CustomHeader[];
}

export interface CustomHeader {
  key: string;
  value: string;
}

export interface AwsSignatureCredentials {
  accessKey: string;
  secretKey: string;
  region?: string;
  service?: string;
  sessionToken?: string;
}

export const CredentialsType = {
  TOKEN: "TOKEN",
  BASIC_AUTH: "BASIC_AUTH",
  OAUTH2: "OAUTH2",
  JWT: "JWT",
  CUSTOM_HEADER: "CUSTOM_HEADER",
  AWS_SIGNATURE: "AWS_SIGNATURE",
};

export const GrantType = {
  AUTHORIZATION_CODE: "code",
  CLIENT_CREDENTIALS: "client_credentials",
  RESOURCE_OWNER_PASSWORD_CREDENTIALS: "password",
};
export const OAuth2SendAs = {
  BODY: "body",
  QUERY_PARAMS: "query_params",
  URLENCODED: "x-www-form-urlencoded",
};
